export default function filterByTypename(__typename: string) {
  return (value: { __typename: any }) => value.__typename === __typename;
}
